<div style="padding: 15px">
  <h3> News segment</h3>
  <div *ngFor="let heading of newsHeading">
    <span>{{heading}}</span>
    <ul *ngFor="let docName of newsDocument">
      <li class="primary-color pointer-cursor clear-filter" *ngIf="docName.split('/')[0] === heading && docName.split('/').length > 1" (click)="openNewsDocument(docName)">
        {{docName.split('/')[1]}}
      </li>
    </ul>
  </div>
</div>
